import z from 'zod';
import { DBLegacyTopicGroupColorSchema } from './schemas';

export const DEFAULT_LEGACY_TOPIC_GROUP_COLOR: z.infer<typeof DBLegacyTopicGroupColorSchema> =
  '#0c374d';

const listAttributes = ['subject', 'groupId', 'label', 'badgeLabel', 'color', 'topics'] as const;

const getAttributes = [...listAttributes] as const;

const updateAttributes = ['label', 'badgeLabel', 'color'] as const;

export const LegacyTopicGroupAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};
